import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "../DealsAndOffers/dealsAndOffers.css";
import ListHomeVisit from "../Home Visit/listHomeVisit";
import ListHomeVisitPayment from "../Home Visit/listPaymentOfHomeVisit";
import "./headerHomeVisit.css";
import { Skeleton } from "antd";

const STORAGE_KEY = "home_visit_header_tab";

const HeaderHomeVisit = () => {
  const [selectedTable, setSelectedTable] = useState(
    localStorage.getItem(STORAGE_KEY) || "home_visit"
  );
  const [loading, setLoading] = useState(false);


  const handleTableSelection = (table) => {
    if (table === selectedTable || loading) return;

    setLoading(true);
    setSelectedTable(table);
    localStorage.setItem(STORAGE_KEY, table);

    setTimeout(() => {
      setLoading(false);
    }, 400);
  };

  return (
    <MainLayout>
      <div className="dealsAndOffers-container">
        <div className={`bg-white border-10 padding-10 shadow-box ${loading ? "disabled-tabs" : ""}`}
          style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", marginBottom: "20px" }}>
          <div className="hover_panel">
            <h4
              className={selectedTable === "home_visit" ? "clicked" : ""}
              onClick={() => handleTableSelection("home_visit")}
            >
              Home Visit List
            </h4>

            <h4
              className={selectedTable === "payment_list_home_visit" ? "clicked" : ""}
              onClick={() => handleTableSelection("payment_list_home_visit")}
            >
              Home Visit Payment List
            </h4>
          </div>
        </div>

        {loading && (
          <div className="tab-loader">
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        )}

        <div className={`fade-wrapper ${loading ? "hide" : ""}`}>
          <div style={{ display: selectedTable === "home_visit" ? "block" : "none" }}>
            <ListHomeVisit />
          </div>

          <div style={{ display: selectedTable === "payment_list_home_visit" ? "block" : "none" }}>
            <ListHomeVisitPayment />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default HeaderHomeVisit;
